import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItemCheckbox } from 'components/Dropdown2';
import Message from 'components/Message';

import messages from '../Schedules.messages';

function SchedulesBoardFilter(props) {
  const { selectedFilterKeys, setSchedulesBoardFilters, filterOptions = [], isStatusFilter, isTypeFilter } = props;

  let message;
  switch (true) {
    case isStatusFilter:
      message = messages.board.filters.selectedStatuses;
      break;

    case isTypeFilter:
    default:
      message = messages.board.filters.selectedTypes;
      break;
  }

  return (
    <Dropdown attachment="left" closeOnSelect={false}>
      <DropdownToggle>
        <Message message={message} values={{ count: selectedFilterKeys.length }} />
      </DropdownToggle>
      <DropdownMenu>
        {filterOptions.map(({ key, label }) => (
          <DropdownItemCheckbox
            key={key}
            isChecked={selectedFilterKeys.includes(key)}
            onClick={checked => {
              const updatedArr = checked
                ? selectedFilterKeys.concat(key)
                : selectedFilterKeys.filter(selectedKey => selectedKey !== key);
              setSchedulesBoardFilters(updatedArr);
            }}>
            {label}
          </DropdownItemCheckbox>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

SchedulesBoardFilter.propTypes = {
  isStatusFilter: PropTypes.bool,
  isTypeFilter: PropTypes.bool,
  selectedFilterKeys: PropTypes.arrayOf(PropTypes.string),
  setSchedulesBoardFilters: PropTypes.func,
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.node,
      query: PropTypes.string,
    })
  ),
};

export default SchedulesBoardFilter;
